// import swipe_mix from '@/mixins/swipe_mix'
// mixins:[swipe_mix],

// @touchstart="swpHandleTouchStart"
// @touchmove="swpHandleTouchMove"
// @touchend="swpHandleTouchEnd"

// import './swipe-events'
// data-swipe-ignore="true"
// import { throttle } from 'lodash'

const swipe_mix = {
  data() {
    this.swp_events = {
      touchstart: this.swpHandleTouchStart,
      touchmove: this.swpHandleTouchMove,
      touchend: this.swpHandleTouchEnd,
    }
    return {
      swp_xDown: null,
      swp_yDown: null,
      swp_xDiff: null,
      swp_yDiff: null,
      swp_timedown: null,
    }
  },
  // computed: {
  //   swp_events() {
  //     return {
  //       touchstart: this.swpHandleTouchStart,
  //       touchmove: this.swpHandleTouchMove,
  //       touchend: this.swpHandleTouchEnd,
  //     }
  //   },
  // },
  methods: {
    swpLeft(eventData, args) {
      // console.log('swipedLeft', { eventData, args })
    },
    swpRight(eventData, args) {
      // console.log('swipedRight', { eventData, args })
    },
    swpUp(eventData, args) {
      // console.log('swipedUp', { eventData, args })
    },
    swpDown(eventData, args) {
      // console.log('swipedDown', { eventData, args })
    },
    // ------------------------------------------------------------
    swpTouchEnd(e, args) {
      // console.log('swpTouchEnd', { e, args })
    },
    swpTouchStart(e, args) {
      // console.log('swpTouchStart', { e, args })
    },
    swpTouchMove(e, args) {
      // console.log('swpTouchMove', { e, args })
    },

    // ------------------------------------------------------------
    swpHandleTouchEnd(e, args) {
      // if the user released on a different target, cancel!
      // if (this.startEl !== e.currentTarget) return

      const swipeThreshold = args?.swp_treshold || 20
      const swipeTimeout = args?.swp_timeout || 500

      const timeDiff = Date.now() - this.swp_timedown
      let eventType = ''
      const changedTouches = e.changedTouches || e.touches || []
      if (Math.abs(this.swp_xDiff) > Math.abs(this.swp_yDiff)) {
        // most significant
        if (Math.abs(this.swp_xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
          if (this.swp_xDiff > 0) {
            eventType = 'swpLeft'
          } else {
            eventType = 'swpRight'
          }
        }
      } else if (Math.abs(this.swp_yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
        if (this.swp_yDiff > 0) {
          eventType = 'swpUp'
        } else {
          eventType = 'swpDown'
        }
      }
      if (eventType !== '') {
        const eventData = {
          e,
          dir: eventType.replace(/swiped-/, ''),
          touchType: (changedTouches[0] || {}).touchType || 'direct',
          xStart: parseInt(this.swp_xDown, 10),
          xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
          yStart: parseInt(this.swp_yDown, 10),
          yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10),
        }

        // all ends here
        this[eventType](eventData, args)
      }

      this.swpTouchEnd(e, args)
      // reset values
      this.swp_xDown = null
      this.swp_yDown = null
      this.swp_timedown = null

      this.swp_xDiff = 0
      this.swp_yDiff = 0
    },
    swpHandleTouchStart(e, args) {
      // console.log(e)
      // this.startEl = e.currentTarget
      this.swp_timedown = Date.now()
      this.swp_xDown = e.touches[0].clientX
      this.swp_yDown = e.touches[0].clientY
      this.swp_xDiff = 0
      this.swp_yDiff = 0

      this.swpTouchStart(e, args)
    },
    swpHandleTouchMove(e, args) {
      if (!this.swp_xDown || !this.swp_yDown) return

      const xUp = e.touches[0].clientX
      const yUp = e.touches[0].clientY
      this.swp_xDiff = this.swp_xDown - xUp
      this.swp_yDiff = this.swp_yDown - yUp

      // this.swpSetPublicVars()
      this.swpTouchMove(e, args)
    },

    // swpSetPublicVars: throttle(function () {
    //   this.swp_swp_xDiff = this.swp_xDiff
    //   this.swp_swp_yDiff = this.swp_yDiff
    //   // console.log('handleTouchMove', this.swp_swp_xDiff, this.swp_swp_yDiff)
    // }, 40),

    // ---
  },
}

export default swipe_mix
